//sub_domain maxLength:  https://www.ovhcloud.com/en-gb/domains/dns-subdomain/#:~:text=DNS%20subdomain%20limits,limit%20of%20127%20DNS%20subdomains.

export const onboarding_constants = {
  sub_domain: {
    maxLength: 63, //for multi level subdomains, each level can only be 63 characters long.url not working have 64 character.
  },
};
